/* ZONA VET SHOP · PRODUCTO DEFINITIVO */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-zv-main-product]').forEach(function (section) {

    if (section.dataset.zvReady === 'true') return;

    section.dataset.zvReady = 'true';

    var variantsNode = section.querySelector('[data-zv-variant-data]');
    var variants = [];

    try {
      variants = variantsNode
        ? JSON.parse(variantsNode.textContent)
        : [];
    } catch(e) {}


    /* ==========================================================
       GALERÍA
    ========================================================== */

    var mainImage =
      section.querySelector('[data-zv-product-main-image]');

    var thumbs =
      section.querySelectorAll('[data-zv-product-thumbnail]');

    thumbs.forEach(function(btn){

      btn.addEventListener('click', function(){

        if(mainImage){

          const newSource = btn.dataset.mediaSrc;
          const newAlt = btn.dataset.mediaAlt || mainImage.alt;

          if(newSource){

            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');

            mainImage.src = newSource;
            mainImage.alt = newAlt;

          }

        }

        thumbs.forEach(function(t){

          t.classList.remove('is-active');

          t.setAttribute(
            'aria-pressed',
            'false'
          );

        });

        btn.classList.add('is-active');

        btn.setAttribute(
          'aria-pressed',
          'true'
        );

      });

    });


    /* ==========================================================
       PRODUCTO / OPCIONES / VARIANTES
    ========================================================== */

    var optionGroups =
      section.querySelectorAll('[data-zv-option-group]');

    var optionButtons =
      section.querySelectorAll('[data-zv-option-value]');

    var variantInput =
      section.querySelector('[data-zv-variant-input]');

    var price =
      section.querySelector('[data-zv-current-price]');

    var compare =
      section.querySelector('[data-zv-product-compare-price]');

    var availability =
      section.querySelector('[data-zv-product-availability]');

    var availabilityText =
      section.querySelector('[data-zv-availability-text]');

    var add =
      section.querySelector('[data-zv-add-button]');


    /* ==========================================================
       ESTADOS EDITORIALES
    ========================================================== */

    var comingSoon =
      section.dataset.comingSoon === 'true';

    var preorder =
      section.dataset.preorder === 'true';

    var ordersOpen =
      section.dataset.ordersOpen === 'true';

    var lowLimit =
      parseInt(
        section.dataset.lowStockLimit || '3',
        10
      );

    var labels = {
      available: section.dataset.availableLabel || 'Disponible',
      lowStock: section.dataset.lowStockLabel || 'Pocas unidades',
      comingSoon: section.dataset.comingSoonLabel || 'Próximamente',
      preorder: section.dataset.preorderLabel || 'Preventa',
      ordersOpen: section.dataset.ordersOpenLabel || 'Pedidos abiertos',
      soldOut: section.dataset.soldOutLabel || 'Agotado',
      add: section.dataset.addLabel || 'Agregar al carrito',
      preorderButton: section.dataset.preorderButtonLabel || 'Comprar en preventa',
      ordersOpenButton: section.dataset.ordersOpenButtonLabel || 'Hacer pedido',
      unavailable: section.dataset.unavailableLabel || 'No disponible'
    };


    function selectedOptions(){

      var selected = [null, null, null];

      optionGroups.forEach(function(group){

        var position =
          parseInt(group.dataset.optionPosition || '0', 10);

        var active =
          group.querySelector('[data-zv-option-value].is-active');

        if (position >= 1 && position <= 3 && active) {
          selected[position - 1] = active.dataset.optionValue;
        }

      });

      return selected;
    }


    function variantMatches(v, selected){

      return (
        (selected[0] == null || v.option1 === selected[0]) &&
        (selected[1] == null || v.option2 === selected[1]) &&
        (selected[2] == null || v.option3 === selected[2])
      );

    }


    function findSelectedVariant(){

      var selected = selectedOptions();

      return variants.find(function(v){
        return variantMatches(v, selected);
      }) || null;

    }


    function optionCombinationExists(position, value){

      var selected = selectedOptions();
      selected[position - 1] = value;

      return variants.some(function(v){
        return variantMatches(v, selected);
      });

    }


    function optionCombinationAvailable(position, value){

      var selected = selectedOptions();
      selected[position - 1] = value;

      return variants.some(function(v){
        return v.available && variantMatches(v, selected);
      });

    }


    function refreshOptionStates(){

      optionButtons.forEach(function(btn){

        var position =
          parseInt(btn.dataset.optionPosition || '0', 10);

        var value = btn.dataset.optionValue;

        var exists =
          optionCombinationExists(position, value);

        var available =
          optionCombinationAvailable(position, value);

        btn.classList.toggle(
          'is-unavailable',
          !available
        );

        btn.disabled = !exists;

        if (!exists) {
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('aria-disabled');
        }

      });

    }


    /* ==========================================================
       ACTUALIZAR VARIANTE
    ========================================================== */

    function updateVariant(v){

      if (!v) return;

      if (variantInput) {
        variantInput.value = v.id;
      }


      /* Precio */

      if (price) {
        price.textContent = v.price || '';
      }

      if (compare) {

        if (v.compare_at_price) {

          compare.textContent =
            v.compare_at_price;

          compare.hidden = false;

        } else {

          compare.textContent = '';
          compare.hidden = true;

        }

      }


      /* ========================================================
         DISPONIBILIDAD
      ======================================================== */

      if (availability) {

        availability.classList.remove(
          'is-available',
          'is-low-stock',
          'is-sold-out',
          'is-coming-soon',
          'is-preorder',
          'is-orders-open'
        );

        var cls = 'is-available';
        var txt = labels.available;


        if (comingSoon) {

          cls = 'is-coming-soon';
          txt = labels.comingSoon;

        }

        else if (preorder) {

          cls = 'is-preorder';
          txt = labels.preorder;

        }

        else if (ordersOpen) {

          cls = 'is-orders-open';
          txt = labels.ordersOpen;

        }

        else if (!v.available) {

          cls = 'is-sold-out';
          txt = labels.soldOut;

        }

        else if (
          v.inventory_management &&
          v.inventory_quantity > 0 &&
          v.inventory_quantity <= lowLimit
        ) {

          cls = 'is-low-stock';
          txt = labels.lowStock;

        }


        availability.classList.add(cls);


        if (availabilityText) {
          availabilityText.textContent = txt;
        }

      }


      /* ========================================================
         BOTÓN
      ======================================================== */

      if (add) {

        if (comingSoon) {

          add.disabled = true;
          add.textContent = labels.comingSoon;

        }

        else if (preorder) {

          add.disabled = !v.available;

          add.textContent =
            v.available
              ? labels.preorderButton
              : labels.unavailable;

        }

        else if (ordersOpen) {

          add.disabled = !v.available;

          add.textContent =
            v.available
              ? labels.ordersOpenButton
              : labels.unavailable;

        }

        else {

          add.disabled = !v.available;

          add.textContent =
            v.available
              ? labels.add
              : labels.soldOut;

        }

      }


      /* ========================================================
         IMAGEN DE VARIANTE
      ======================================================== */

      if (v.featured_media_id) {

        var target =
          section.querySelector(
            '[data-media-id="' +
            v.featured_media_id +
            '"]'
          );

        if (target) {
          target.click();
        }

      }

      /* URL compartible de la variante, sin recargar */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch(e) {}

    }


    /* ==========================================================
       BOTONES DE OPCIÓN
    ========================================================== */

    optionButtons.forEach(function(btn){

      btn.addEventListener('click', function(){

        if (btn.disabled) return;

        var group =
          btn.closest('[data-zv-option-group]');

        if (!group) return;

        group
          .querySelectorAll('[data-zv-option-value]')
          .forEach(function(b){

            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');

          });

        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        refreshOptionStates();

        var selectedVariant =
          findSelectedVariant();

        if (selectedVariant) {
          updateVariant(selectedVariant);
        }

      });

    });

    refreshOptionStates();

    var initialVariant =
      findSelectedVariant();

    if (initialVariant) {
      updateVariant(initialVariant);
    }


    /* ==========================================================
       CANTIDAD
    ========================================================== */

    var qty =
      section.querySelector('[data-zv-quantity-input]');

    var minus =
      section.querySelector('[data-zv-quantity-minus]');

    var plus =
      section.querySelector('[data-zv-quantity-plus]');


    if (qty && minus) {

      minus.addEventListener('click', function(){

        qty.value = Math.max(
          parseInt(qty.min || '1', 10),
          parseInt(qty.value || '1', 10) - 1
        );

      });

    }


    if (qty && plus) {

      plus.addEventListener('click', function(){

        var next =
          parseInt(qty.value || '1', 10) + 1;

        if (qty.max) {

          next = Math.min(
            next,
            parseInt(qty.max, 10)
          );

        }

        qty.value = next;

      });

    }

  });

});


/* ==========================================================
   ACORDEONES GENERALES
========================================================== */

(function(){

  function initZVAccordionGroups(root){

    (root || document)
      .querySelectorAll('[data-zv-accordion-group]')
      .forEach(function(group){

        if (
          group.dataset.zvAccordionReady === 'true'
        ) return;

        group.dataset.zvAccordionReady = 'true';

        group
          .querySelectorAll('details')
          .forEach(function(detail){

            detail.addEventListener(
              'toggle',
              function(){

                if(!detail.open) return;

                group
                  .querySelectorAll('details')
                  .forEach(function(other){

                    if(other !== detail) {
                      other.open = false;
                    }

                  });

              }
            );

          });

      });

  }

  document.addEventListener(
    'DOMContentLoaded',
    function(){
      initZVAccordionGroups(document);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function(event){
      initZVAccordionGroups(event.target);
    }
  );

})();


/* ==========================================================
   DATOS DEL PRODUCTO
========================================================== */

(function(){

  function initZVProductData(root){

    (root || document)
      .querySelectorAll('[data-zv-product-data]')
      .forEach(function(section){

        if (
          section.dataset.zvProductDataReady === 'true'
        ) return;

        section.dataset.zvProductDataReady = 'true';

        var items =
          section.querySelectorAll(
            '.zv-product-data__accordion'
          );

        items.forEach(function(item){

          item.addEventListener(
            'toggle',
            function(){

              if(!item.open) return;

              items.forEach(function(other){

                if(other !== item) {
                  other.open = false;
                }

              });

            }
          );

        });

      });

  }

  document.addEventListener(
    'DOMContentLoaded',
    function(){
      initZVProductData(document);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function(event){
      initZVProductData(event.target);
    }
  );

})();